import { useState, useEffect } from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";

function LocationLogger() {
  const [metaData, setMetaData] = useState([]);
  

  const get_meta = async () => {
    console.log("meta_url", window.location.href);
    const fullUrl = "https://alahdeen.com" + window.location.pathname;
  
    try {
      const response = await axios.post(
        "/pro/seo/get_meta.php",
        { url: fullUrl }, // ✅ send JSON
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
  
      setMetaData(response.data); // ✅ update your state
      console.log(response.data);
    } catch (error) {
      if (error.response) {
        console.error("Server responded with error:", error.response.data);
      } else if (error.request) {
        console.error("No response received. Request was:", error.request);
      } else {
        console.error("Axios config error:", error.message);
      }
    }
  };
  

  useEffect(() => {
      if(!window.isExcluded) {
        get_meta();
      }
  }, []);

  return (
    <>
      {metaData.length == 0 ? <></>: metaData[0].msg=="pass"?<>
        
        <Helmet>
          <title>{metaData[0].t}</title>
          <meta name="description" content={metaData[0].d} />
          <meta name="keywords" content={metaData[0].k} />
          <meta property="og:title" content={metaData[0].t} />
          <meta property="og:description" content={metaData[0].d} />
          <meta
            property="og:image"
            content="https://alahdeen.com/assets/images/logos/logo.png"
          />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:type" content="business.business" />
          <meta property="og:site_name" content="Alahdeen" />
          <meta name="robots" content={metaData[0].ex2} />
          <link rel="canonical" href={metaData[0].ex1} />

        </Helmet>
      </>:<>
      <Helmet>
          <title>Alahdeen | Best B2B Marketplace</title>
          <meta
            name="description"
            content="Alahdeen connects buyers and sellers, providing a complete package from online selling, managing inventory, and warehousing to logistics, and Products."
          />
          <meta name="keywords" content="Best b2b marketplace Pakistan" />
          <meta property="og:title" content="Alahdeen | B2B Marketplace" />
          <meta
            property="og:description"
            content="Alahdeen connects buyers and sellers, providing a complete package from online selling, managing inventory, and warehousing to logistics, and Products"
          />
          <meta
            property="og:image"
            content="https://alahdeen.com/assets/images/logos/logo.png"
          />
          <meta property="og:url" content="https://www.alahdeen.com/" />
          <meta property="og:type" content="business.business" />
          <meta property="og:site_name" content="Alahdeen" />
        </Helmet>
        </>}

    </>
  );
}

export default LocationLogger;
